import { DEFAULT_PAGE_SIZE } from "@/constants/miscConstants";
import { useState, useEffect, SetStateAction, Dispatch } from "react";

interface PaginationState {
  pageIndex: number;
  pageSize: number;
}

const usePagination = (
  url: string,
  defaultPageSize: number = DEFAULT_PAGE_SIZE,
): [PaginationState, Dispatch<SetStateAction<PaginationState>>] => {
  const localStorageKey = `${url}`;

  const [pagination, setPagination] = useState<PaginationState>(() => {
    if (typeof window !== "undefined") {
      const storedValue = localStorage.getItem("pagination");
      if (storedValue) {
        try {
          const parsed = JSON.parse(storedValue);
          return {
            pageIndex: 0,
            pageSize: parsed[localStorageKey] || defaultPageSize,
          };
        } catch (e) {
          console.error("Failed to parse stored pagination", e);
        }
      }
    }
    return {
      pageIndex: 0,
      pageSize: defaultPageSize,
    };
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedValue = localStorage.getItem("pagination");
      if (storedValue) {
        const parsed = JSON.parse(storedValue);
        parsed[localStorageKey] = pagination.pageSize;
        localStorage.setItem("pagination", JSON.stringify(parsed));
      } else {
        const parsed = {
          [localStorageKey]: pagination.pageSize,
        };
        localStorage.setItem("pagination", JSON.stringify(parsed));
      }
    }
  }, [pagination.pageSize, localStorageKey]);

  // No need to wrap the setter - we can return setPagination directly
  return [pagination, setPagination];
};

export default usePagination;
